<template>
  <bm-overlay
    :class="{samples: true}"
    :style="{'z-index':zIndex}"
    pane="labelPane"
    @draw="draw">
    <img class="carShow" :src="require('../../images/car/'+type+'.png')" />
    <div class="nameShow">{{name}}<span class="statusShow" :class="['statusShow'+status]">{{statusName}}</span></div>
    <div v-text="code" class="codeShow"></div>
    <div v-text="address" class="addressShow"></div>
    <div class="close" @click="handleClick">×</div>
    <div class="lineOver"></div>
    <div class="circleCon">
      <div class="circleItem">
        <div class="circleShow">
          <Mycircle :id="circle1" title="剩余油量" color="#1890FF" content="100" :percent="oilValue" unit="%" name1="当前油量" name2="总油量"></Mycircle>
        </div>
        
      </div>
      <div class="circleItem">
        <div class="circleShow">
          <Mycircle :id="circle2" title="今日已作业时长" color="#F56C6C" content="14.5" :percent="workTimeValue" unit="h" name1="当前时长" name2="平均时长"></Mycircle>
        </div>
      </div>
      <div class="circleItem">
        <div class="circleShow">
          <Mycircle :id="circle3" title="今日已作业里程" color="#52C41A" content="0.62" :percent="workMileageValue" unit="km" name1="当前里程" name2="平均里程"></Mycircle>
        </div>
      </div>
    </div>
    <div class="btnToOther">
      <span class="toOtherText" @click="goToInfo">查看更多</span>
      <div class="toOtherIcon"></div>
    </div>
  </bm-overlay>
</template>

<script>
import BmOverlay from "vue-baidu-map/components/overlays/Overlay.vue";
import Mycircle from "../chart/circle4"
import {genID} from "../../utils/commons"
export default {
  props: ['zIndex','text', 'position', 'active','name','code','address','type','oilValue','workTimeValue','workMileageValue','status'],
  data(){
    return{
      setColor: '#1890FF',
      circle1: genID(8),
      circle2: genID(8),
      circle3: genID(8),
    }
  },
  
  computed: {
    // 计算属性的 getter
    statusName: function () {
      // `this` 指向 vm 实例
      console.log(this.status)
      let status = this.status
      let name = ''
      if (status == 0) {
        name= "离线";
      } else if (status == 1) {
        name= "空闲";
      } else if (status == 2) {
        name= "作业中";
      } else if (status == 3) {
        name= "紧停";
      } else if (status == 4) {
        name= "暂停";
      } else if (status == null) {
        name= "未知";
      }
      return name
    }
  },
//   watch: {
    // position: {
    //   handler () {
        // this.$refs.customOverlay.reload()
    //   },
    //   deep: true
    // }
//   },
  methods: {
    handleClick () {
      this.$emit('closeOver',this.code)
    },
    goToInfo () {
      this.$emit('goToInfo',this.code,this.name)
    },
    draw ({el, BMap, map}) {
      const {lng, lat} = this.position
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat))
      el.style.left = pixel.x + 20 + 'px'
      el.style.top = pixel.y - 160 + 'px'
    }
  },
  components:{
      BmOverlay,
      Mycircle
  }
}
</script>

<style lang="scss" scoped>
.samples {
  width: 360px;
  height: 320px;
  background: #ffffff;
  overflow: hidden;
  border-radius: 2px;
  box-shadow: 0px 1px 2px 0px #e1e1e1,0px 2px 4px 0px #e1e1e1,0px 2px 4px 0px #e1e1e1;
  padding: 10px;
  position: absolute;
  padding: 17px 24px;
  z-index: 1;
}
.carShow{
  width: 106px;
  height: 75px;
  position: absolute;
  top: 27px;
  left: 24px;
  background-size: 100% 100%;
}

.nameShow{
color: #404040;
font-family: Noto Sans SC;
font-weight: medium;
font-size: 18px;
line-height: normal;
letter-spacing: 0px;
text-align: left;
height: 26px;
line-height: 26px;
top: 27px;
left: 154px;
position: absolute;
}
.codeShow{
color: #8C8C8C;
font-family: Noto Sans SC;
font-weight: regular;
font-size: 14px;
line-height: normal;
letter-spacing: 0px;
text-align: left;
height: 20px;
line-height: 20px;
top: 57px;
left: 154px;
position: absolute;
}
.addressShow{
color: #8C8C8C;
font-family: Noto Sans SC;
font-weight: regular;
font-size: 14px;
line-height: normal;
letter-spacing: 0px;
text-align: left;
height: 20px;
line-height: 20px;
top: 81px;
left: 154px;
position: absolute;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
width: 185px;
}
.close{
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
color: #8C8C8C;
font-family: Noto Sans SC;
font-weight: regular;
font-size: 20px;
line-height: normal;
letter-spacing: 0px;
position: absolute;
top: 10px;
right: 10px;
}
.samples.active {
  background: rgba(0,0,0,0.75);
  color: #fff;
}

.lineOver{
  width: 312px;
  height: 1px;
  background-color: #F0F0F0;
  position: absolute;
  top: 128px;
  left: 50%;
  transform: translateX(-50%);
}

.circleCon{
  width: 100%;
  height: 152px;
  position: absolute;
  left: 0;
  top: 129px;
  padding: 0 12px;
  display: flex;
  z-index: 1;
}
.circleItem{
  flex: 1;
  position: relative;
  padding:0 12px;
}
.circleShow{
  position: absolute;
  width: 80px;
  height: 80px;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  
}
.btnToOther{
  position: absolute;
  width: 100%;
  height: 40px;
  bottom: 0;
  left: 0;
  border-top: 1px solid #F0F0F0;
  cursor: pointer;
  .toOtherText{
    color: #595959;
    font-family: Noto Sans SC;
    font-weight: regular;
    font-size: 16px;
    line-height: normal;
    letter-spacing: 0px;
    text-align: left;
    position: absolute;
    height: 20px;
    line-height: 20px;
    top: 50%;
    transform: translateY(-50%);
    left: 40%;
  }
  .toOtherIcon{
    height: 20px;
    width: 20px;
    background-image: url('../../images/more.png');
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 58%;
  }
}
.statusShow{
  font-size: 14px;
  display: inline-block;
  // height: 24px;
  line-height: 18px;
  padding: 1px 8px;
  // background-color: rgba(82,196,26,0.15);
  // color: #52C41A;
  margin-left: 8px;
}
.statusShow0{
  background-color: rgba(0,0,2505,0.1);
  color: rgba(0,0,0,0.65);
}
.statusShow1{
  background-color: rgba(250,173,20,0.15);
  color: #FAAD14;
}
.statusShow2{
  background-color: rgba(82,196,26,0.15);
  color: #52C41A;
}
.statusShow3{
  background-color: rgba(245,34,45,0.15);
  color: #F5222D
}
.statusShow4{
  background-color: rgba(235,47,150,0.1);
  color: #EB2F96
}
</style>